import React from "react";
import "./Delete_app.css";

function DeleteApp() {
  return (
    <div className="Delete_app">
      <div className="Delete_app-body">
        <h1>LIFE MISSION のアプリ削除について</h1>
        <p>
          アプリを削除することにより
          <br />
          アプリ内のデータは削除されます
          <br />
          <br />
          ログアウトのみの場合は、データは削除されません
        </p>
      </div>
    </div>
  );
}

export default DeleteApp;
